class PenalidadesDadosGeraisUrlBuilder {
	constructor(tipo) {
		this.PATH = tipo.path
	}

	getUrlBuscarOrgaosSancionadoresPenalidade() {
		return `api/${this.PATH}/penalidades/orgaos-sancionadores`
	}
	getUrlBuscarFornecedoresPenalidade() {
		return `api/${this.PATH}/penalidades/fornecedores`
	}
	getUrlBuscarTiposPenalidade(idEntidade) {
		return `api/${this.PATH}/penalidades/tipos/${idEntidade}`
	}
	getUrlSalvarDadosGeraisPenalidade() {
		return `api/${this.PATH}/penalidades/dados-gerais`
	}
	getUrlBuscarDadosGeraisPenalidade(idPenalidade) {
		return `api/${this.PATH}/penalidades/${idPenalidade}`
	}
}

export default PenalidadesDadosGeraisUrlBuilder
